// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"LocationsFilters--checkboxWrapper"};